









































import {Vue, Component, Watch, Prop} from "vue-property-decorator";
import {CommentsType} from "@/types/riskPrioritization.type";
import Tooltip from "@/components/Tooltip.vue";

@Component({components: {Tooltip}})
export default class Comments extends Vue {
    @Prop() private question!: any;
    @Prop() private isOpen!: boolean;

    get sections(): CommentsType[] {
        const arr: CommentsType[] = [];

        Object.entries(this.question).forEach((entry: any) => {
            const obj: CommentsType = {name: "", comments: []};
            obj.name = entry[1].sectionTitle;
            if (entry[0] !== "additionalInformation") {
                Object.entries(entry[1]).forEach((subEntry: any) => {
                    if (subEntry[0] === "questions") {
                        Object.entries(subEntry[1]).forEach((item: any) => {
                            if (
                                item[1].userInput.comments !== null &&
                                item[1].userInput.comments !== undefined
                            )
                                obj.comments.push({
                                    subTitle: item[1].question,
                                    answer: item[1].userInput.comments
                                });
                        });
                    }
                });
            } else {
                Object.entries(entry[1].questions).forEach((item: any) => {
                    if (item[1].userInput.answer !== null) {
                        obj.comments.push({
                            subTitle: item[1].question,
                            answer: item[1].userInput.answer
                        });
                    }
                });
            }
            if (obj.comments.length > 0) {
                arr.push(obj);
            }
        });
        return arr;
    }
}
